export default "/_next/static/chunks/fonts/HK Grotesk Light Italic-f3f97301451846a1d769bcee2784b6aa.otf";